export const gameServerTopics: string[] = [
    "Servidores para Videojuegos",
    "Game Server",
    "Servidor de eSports",
    "Hosting de Juegos",
    "Dedicated Gaming Server",
    "Servidor para Minecraft",
    "Servidor para CS:GO",
    "Servidor para GTA V",
    "Servidor Ark",
    "Hosting de Juegos Online",
    "Game Cloud",
    "Servidores con Baja Latencia",
    "Anti-DDoS Gaming",
    "Hosting para Streamers",
    "Game Cluster",
    "Servidores Battle Royale",
    "Consolas Virtuales",
    "Servidores para Desarrollo de Videojuegos"
  ];
  